import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";

const InputCheckboxReverse = (props) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(props.checked || props.value);
  }, [props.checked, props.value]);

  return (
    <div className={styles.container}>
      <input
        id={props.name}
        name={props.name}
        type="checkbox"
        checked={checked}
        onChange={props.onChange}
      />
      <label htmlFor={props.name} className={styles.Label}>
        <div className={styles.children}>{props.children}</div>
        <div className={styles.slice}></div>
      </label>
    </div>
  );
};

export default InputCheckboxReverse;
